import type { Action } from "@mailhand/core/schemas";
import { ACTION_TYPE_LABEL } from "../../app/labels.js";

export function isRunnable(action: Action | undefined): boolean {
  return action !== undefined && action.type !== "hold" && action.type !== "ignore";
}

/** The approval checkbox starts from the action's own setting. */
export function approvesByDefault(action: Action | undefined): boolean {
  return action !== undefined && action.type !== "hold" && action.type !== "ignore" && action.mode === "approve";
}

export function actionOptionLabel(action: Action): string {
  return `${action.name} · ${ACTION_TYPE_LABEL[action.type]}`;
}
